import { render, staticRenderFns } from "./coupon-group.vue?vue&type=template&id=3d698f20&scoped=true&"
import script from "./coupon-group.vue?vue&type=script&lang=js&"
export * from "./coupon-group.vue?vue&type=script&lang=js&"
import style0 from "./coupon-group.vue?vue&type=style&index=0&id=3d698f20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d698f20",
  null
  
)

export default component.exports